import React, { useState } from 'react';

function CustomFileUploader({ callback = undefined }) {
  const [files, setFiles] = useState([]);

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles(droppedFiles);
    if (callback && droppedFiles.length > 0) callback(droppedFiles[0]); // ✅ only first file
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileSelect = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    if (callback && selectedFiles.length > 0) callback(selectedFiles[0]); // ✅ only first file
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      style={{
        border: '2px dashed #ccc',
        borderRadius: '10px',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
      }}
    >
      <p>Drag and drop files here, or click to select files</p>

      <input
        type="file"
        multiple
        onChange={handleFileSelect}
        style={{ display: 'none' }}
        id="fileInput"
      />

      <label htmlFor="fileInput" style={{ cursor: 'pointer', color: '#007bff' }}>
        Browse Files
      </label>

      <div style={{ marginTop: '20px' }}>
        {files.map((file, index) => (
          <div key={index}>
            <strong>{file.name}</strong> ({(file.size / 1024).toFixed(2)} KB)
          </div>
        ))}
      </div>

      <div style={{ marginTop: '10px', fontStyle: 'italic', color: '#333' }}>
        {files.length > 0
          ? `Your selected file${files.length > 1 ? 's are' : ' is'}: ${files.map(f => f.name).join(', ')}`
          : 'No files selected'}
      </div>
    </div>
  );
}

export default CustomFileUploader;
